/*
 * formatToLongDate
 * --------------------------------------------------------------------------
 * Convert a date-like input (epoch ms, ISO string, or Date) into a long
 * human-readable date string like "June 4, 2026".
 */

export const formatToLongDate = (input) => {
    return new Date(input).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
};

export default formatToLongDate;
